import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { Router } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class ValidateParamsGuard  {
    constructor(private router: Router) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        _state: RouterStateSnapshot
    ): Observable<boolean> | boolean {
        if (!route.data.hasOwnProperty('parametersSchema')) {
            return true;
        }

        const { params: paramsSchema, queryParams: queryParamsSchema, failRedirectURL } = route.data.parametersSchema;

        if (!paramsSchema && !queryParamsSchema) {
            return true;
        }

        const isValidateParams =
            this.validate(paramsSchema || {}, route.params || {}) &&
            this.validate(queryParamsSchema || {}, route.queryParams || {});

        if (!isValidateParams && failRedirectURL) {
            this.router.navigate([failRedirectURL]);
            return false;
        }

        return true;
    }

    private validate(paramsSchema: { [key: string]: string }, params): boolean {
        for (const [property, validator] of Object.entries(paramsSchema)) {
            if (!params[property] || !new RegExp(validator).test(params[property])) {
                return;
            }
        }

        return true;
    }
}
